import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Icons } from './Icons';
import { useAuthModal } from '../../contexts/AuthContext';

export const UnauthenticatedHeader: React.FC = () => {
  const { openAuthModal } = useAuthModal();
  const location = useLocation();
  const isTeachPage = location.pathname === '/teach';

  return (
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 px-6">
      <div className="max-w-5xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="bg-white/20 text-white p-2 rounded-lg">
            <Icons.BookOpen className="w-6 h-6" />
          </div>
          <div className="flex flex-col">
            <span className="font-serif font-bold text-xl text-white tracking-tight leading-none">Bible Aware</span>
            <p className="text-sm opacity-90 md:hidden">Sign up to save progress</p>
            <p className="text-sm opacity-90 hidden md:block">Want to track your progress? Sign up to save your course progress and earn rewards</p>
          </div>
        </Link>

        <div className="flex items-center gap-3">
          <button
            onClick={() => openAuthModal('signup', isTeachPage ? 'teacher' : 'student')}
            className="px-6 py-2 bg-white text-primary font-bold rounded-lg hover:bg-gray-100"
          >
            <span className="md:hidden">Sign Up</span>
            <span className="hidden md:inline">Sign Up Free</span>
          </button>
          <button
            onClick={() => openAuthModal('login')}
            className="px-6 py-2 text-white border-2 border-white font-bold rounded-lg hover:bg-white hover:text-primary transition-colors"
          >
            Login
          </button>
        </div>
      </div>
    </div>
  );
};
